'use client'
import type { ReactNode } from 'react'
import { createContext, useContext, useEffect, useId, useRef, useState } from 'react'
import { cx } from '../utils'

export function Avatar({
  src,
  name,
  size = 'md',
}: {
  src?: string | null
  name?: string | null
  size?: 'sm' | 'md' | 'lg'
}) {
  const sizeClass = size === 'sm' ? 'h-6 w-6 text-[12px]' : size === 'lg' ? 'h-10 w-10 text-[16px]' : 'h-8 w-8 text-[14px]'
  const initials = name
    ? name.slice(0, 2).toUpperCase()
    : '??'

  if (src) {
    return (
      <img
        src={src}
        alt={name ?? 'Avatar'}
        className={cx(sizeClass, 'rounded-full object-cover')}
      />
    )
  }

  return (
    <span
      className={cx(
        sizeClass,
        'inline-flex items-center justify-center rounded-full bg-accent-soft font-medium text-accent',
      )}
    >
      {initials}
    </span>
  )
}
